/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";

import "./sliderSection.css";

import "bootstrap/dist/css/bootstrap.css";
import MyCarousel from "./MyCarousel";
import AboutSectionContentOnly from "./AboutSectionContentOnly";
import CompanyOverView from "./CompanyOverView";
import BusinessModel from "../about/BusinessModel";

const Home = ({ setIsActive, isActive }) => {
  const options = {
    fade: true,
    accessibility: true,
    pageDots: false,
    loop: true,
    dots: false,
    setGallerySize: false,
    wrapAround: true,
    margin: 10,
    nav: false,
    autoplay: true,
    autoplayTimeout: 2000, // Set to 0 to disable initial timeout
    autoplaySpeed: 3000,
    autoplayHoverPause: false,
    prevNextButtons: false,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 3,
      },
      1000: {
        items: 5,
      },
    },
  };
  return (
    <>
      <MyCarousel isActive={isActive} setIsActive={setIsActive} />

      {/* ================USP Section=================*/}
      <section id="usp" className="text-center usp-wrapper">
        <Link className="usp-wrp" target="_blank">
          <img
            src={require("../../static/img/tata.png")}
            alt="USP"

            style={{ width: "150px" }}
          />

        </Link>
        <Link
          className="usp-wrp"
          target="_blank"
          to="https://dialmytrip.com/Home/Dialmytrip/certifications/irdai.pdf"
        >
          <img
            src="https://services.dialmytrip.com/Home/couponfares/assets_new/img/partners/usp-irctc.png"
            alt="USP"
            width={100}
          />

        </Link>
        <Link
          className="usp-wrp"
          target="_blank"
          to="https://dialmytrip.com/Home/Dialmytrip/certifications/amfi.pdf"
        >
          <img
            src="https://services.dialmytrip.com/Home/couponfares/assets_new/img/partners/usp-irdai.png"
            alt="USP"
            width={100}
          />

        </Link>
        <Link
          className="usp-wrp"
          target="_blank"
          to="https://dialmytrip.com/Home/Dialmytrip/certifications/irctc.pdf"
        >
          <img
            src="https://services.dialmytrip.com/Home/couponfares/assets_new/img/partners/usp-amfi.png"
            alt="USP"
            width={100}
          />

        </Link>
        <Link
          className="usp-wrp"
          target="_blank"
          to="https://dialmytrip.com/Home/Dialmytrip/certifications/nsdl.pdf"
        >
          <img
            src={require("../../static/img/bbps.jpeg")}
            alt=""
            width={100}
            style={{ mixBlendMode: "darken" }}
          />


        </Link>
        <Link
          className="usp-wrp"
          target="_blank"
          to="https://bcfi.org.in/dialmytrip-tech-private-limited/"
        >
          <img
            src="https://services.dialmytrip.com/Home/couponfares/assets_new/img/partners/utiitsl.png"
            alt="USP"
            width={100}
          />

        </Link>
        <Link
          className="usp-wrp"
          target="_blank"
          to="https://dialmytrip.com/Home/Dialmytrip/certifications/uti.pdf"
        >
          <img
            src="https://services.dialmytrip.com/Home/couponfares/assets_new/img/partners/usp-nsdl.png"
            alt="USP"
            width={100}
          />

        </Link>
        <Link
          className="usp-wrp"
          target="_blank"
          to="https://bcfi.org.in/dialmytrip-tech-private-limited/"
        >
          <img
            src={require("../../static/img/airtel.png")}
            alt=""
            width={100}
          />

        </Link>
        <Link
          className="usp-wrp"
          target="_blank"
          to="https://bcfi.org.in/dialmytrip-tech-private-limited/"
        >

          <img
            src="https://services.dialmytrip.com/Home/couponfares/assets_new/img/partners/usp-bcfi.png"
            alt="USP"
            width={100}
          />

        </Link>

      </section>
      {/*========================End USP Section=====================*/}




      <AboutSectionContentOnly />

      <CompanyOverView />

      <BusinessModel />
      <section id="achievement" class=" py-4" style={{ marginBottom: "80px" }}>
        <div class="container-fluid">
          <div class="section-header">
            <h3>Our Professional Certifications & Affiliations</h3>
          </div>

          <div class="row">
            <OwlCarousel className="owl-theme" {...options}>
              <div class="item">
                <div class="achive-wrp">
                  <img
                    src={require("../../static/img/partners/nsdl.png")}
                    alt="Partners"
                  />
                </div>
              </div>
              <div class="item">
                <div class="achive-wrp">
                  <img
                    src={require("../../static/img/partners/irctc.png")}
                    alt="Partners"
                  />
                </div>
              </div>
              <div class="item">
                <div class="achive-wrp">
                  <img
                    src={require("../../static/img/partners/utiitsl.png")}
                    alt="Partners"
                  />
                </div>
              </div>
              <div class="item">
                <div class="achive-wrp">
                  <img
                    src={require("../../static/img/partners/irdai.png")}
                    alt="Partners"
                  />
                </div>
              </div>
              <div class="item">
                <div class="achive-wrp">
                  <img
                    src={require("../../static/img/partners/xiarch.png")}
                    alt="Partners"
                  />
                </div>
              </div>
              <div class="item">
                <div class="achive-wrp">
                  <img
                    src={require("../../static/img/partners/prabhuMoney.png")}
                    alt="Partners"
                  />
                </div>
              </div>
              <div class="item">
                <div class="achive-wrp">
                  <img
                    src={require("../../static/img/partners/redbus.png")}
                    alt="Partners"
                  />
                </div>
              </div>
              <div class="item">
                <div class="achive-wrp">
                  <img
                    src={require("../../static/img/partners/paytm.png")}
                    alt="Partners"
                  />
                </div>
              </div>
              <div class="item">
                <div class="achive-wrp">
                  <img
                    src={require("../../static/img/partners/airtel.png")}
                    alt="Partners"
                  />
                </div>
              </div>
              <div class="item">
                <div class="achive-wrp">
                  <img
                    src={require("../../static/img/partners/mosambee.png")}
                    alt="Partners"
                  />
                </div>
              </div>
            </OwlCarousel>
          </div>
        </div>
      </section>


    </>
  );
};

export default Home;
